import LocaleSwitcher from './LocaleSwitcher';

export default LocaleSwitcher;